import { LicenseStatusResource } from "client/resources";

export function isWithinLicenceLimit(status: LicenseStatusResource, key: string) {
    const entry = status && status.Limits.find(l => l.Name === key);

    return !entry ? false : entry.CurrentUsage < entry.EffectiveLimit;
}

export default isWithinLicenceLimit;
